import React from 'react';
import type { BookingDetail } from '../../../types';

interface BookingActionsProps {
  status: BookingDetail['status'];
  isConfirming: boolean;
  isCancelling: boolean;
  onConfirm: () => void;
  onCancelClick: () => void;
}

export const BookingActions: React.FC<BookingActionsProps> = ({
  status,
  isConfirming,
  isCancelling,
  onConfirm,
  onCancelClick,
}) => {
  // Read-only states (no actions)
  if (status === 'cancelled' || status === 'completed' || status === 'no_show') {
    return null;
  }

  const isLoading = isConfirming || isCancelling;

  return (
    <div className="flex-shrink-0 bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] p-4 pb-24 md:pb-4 md:rounded-b-2xl">
      <div className="space-y-3">
        {/* Confirm Button - Only for pending */}
        {status === 'pending' && (
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="w-full py-4 bg-green-600 hover:bg-green-700 active:bg-green-800 text-white font-semibold rounded-xl shadow-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isConfirming ? (
              <>
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                <span>Confirming...</span>
              </>
            ) : (
              <>
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span>Confirm Booking</span>
              </>
            )}
          </button>
        )}

        {/* Cancel Button - For pending and confirmed */}
        <button
          onClick={onCancelClick}
          disabled={isLoading}
          className="w-full py-4 bg-white border-2 border-red-600 text-red-600 font-semibold rounded-xl hover:bg-red-50 active:bg-red-100 transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isCancelling ? (
            <>
              <div className="w-5 h-5 border-2 border-red-600 border-t-transparent rounded-full animate-spin" />
              <span>Cancelling...</span>
            </>
          ) : (
            <>
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
              <span>Cancel Booking</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};
